import { DesfechoInput, ProcedimentoAtendimentoInput, RacionalidadeEmSaudeEnum } from 'graphql/types.generated'
import { convertNovoAtendimentoModelToInput } from 'view/atendimentos/converter'

import { ManterCidadaoLista } from './components/DesfechoAtendimentoPanel'
import { DesfechoFormModel } from './DesfechoForm'

export const convertDesfechoFormToInput = (cidadaoId: ID, form: DesfechoFormModel): DesfechoInput =>
  form && {
    tipoAtendimento: form.tipoAtendimento,
    atendimentoCompartilhadoId: form.atendimentoCompartilhado?.id,
    procedimentosAdministrativos: form.procedimentosAdministrativos?.map(
      (procedimento) =>
        ({
          id: procedimento.procedimento.id,
          cid10PrincipalId: procedimento.procedimento.procedimentoReferencia?.id,
          automatico: false,
        } as ProcedimentoAtendimentoInput)
    ),
    fichaNotificacaoCasoSuspeito: form.fichasNotifiacaoCasoSuspeito?.map((ficha) => ficha.fichaNotificacao.id),
    racionalidadeEmSaude: form.racionalidadeEmSaude as RacionalidadeEmSaudeEnum,
    condutas: form.conduta,
    condutasOdonto: form.condutasOdonto,
    fornecimentosOdonto: form.fornecimento,
    tipoConsultaOdonto: form.tipoConsulta,
    desfechoAtendimento: form.desfechoAtendimento && {
      manterCidadaoLista: form.desfechoAtendimento.manterCidadaoLista === ManterCidadaoLista.SIM,
      novoAtendimento:
        form.desfechoAtendimento.novoAtendimento?.agendados?.length > 0
          ? undefined
          : convertNovoAtendimentoModelToInput(cidadaoId, form.desfechoAtendimento.novoAtendimento),
      novoAtendimentoAgendado:
        form.desfechoAtendimento.novoAtendimento?.agendados?.length > 0
          ? { agendado: form.desfechoAtendimento.novoAtendimento.agendados?.[0] }
          : undefined,
    },
  }
